import { render, staticRenderFns } from "./BotfooterHe.vue?vue&type=template&id=9d0752c0&"
import script from "./BotfooterHe.vue?vue&type=script&lang=js&"
export * from "./BotfooterHe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports